import { JSONContent } from '@tiptap/react'
import TiptapViewer from '../atoms/TiptapViewer';
import { Button, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../configureStore';
import { Applicant, seenWelcome } from '../../redux/reducer/applicant';
import { useMemo } from 'react';
import { ConfigStepId } from '../../utils/configuration';

export interface WelcomeParams {
    jsonContent: JSONContent;
    continueText?: string;
}

interface WelcomeFunctionParams extends WelcomeParams {
}

const Welcome = ({
    jsonContent,
    continueText = 'Continue',
}: WelcomeFunctionParams) => {
    const dispatch = useDispatch<AppDispatch>();

    const institution = useSelector<RootState, { name: string; institutionId: string; } | undefined>(({ configuration }) => configuration.institution);
    const applicant = useSelector<RootState, Applicant | null>(({ applicant: { applicant: a } }) => a);

    const content = useMemo<JSONContent>(() => {
        const replaceObject = {
            magicLink: '',
            applicantName: applicant?.name ?? 'Applicant',
            clientName: institution?.name,
        }

        let template: string = JSON.stringify(jsonContent);
        if (replaceObject) {
            const getNestedValue = (obj: any, path: string): any => {
                return path.split('.').reduce((current, key) => current?.[key], obj) ?? '';
            };

            const templateRegex = /\|([^|]+)\|/g;

            template = template.replace(templateRegex, (match, path) => {
                const value = getNestedValue(replaceObject, path);
                return value !== undefined && value !== null ? String(value) : match;
            });
        }

        return JSON.parse(template);
    }, [applicant, institution, jsonContent])
    return (
        <>
            <TiptapViewer content={content} />
            <Row justify='end'>
                <Button
                    type='primary'
                    onClick={() => {
                        dispatch(seenWelcome({
                            input: {
                                step: ConfigStepId.welcome,
                            },
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('accessToken') ?? ''}`,
                            },
                        }))
                        // onContinue();
                    }}
                >
                    {continueText}
                </Button>
            </Row>
        </>
    );
};

export default Welcome;
